import React, { useEffect, useState } from "react";
import Navbar from "../../components/Navbar";
import Sidebar from "../../components/Sidebar";
import Filters from "../../components/Filters";
import { useSelector, useDispatch } from "react-redux";
import "./style.scss";
import { getSkillActivation } from "../../services/graphs/actions";
import AreaChartBasic from "../../components/Graphs/AreaChartBasic";
import Footer from "../../components/Footer";
import Loader from "../../components/Loader";
import NoDataAvailable from "../../components/NoDataAvailable";

const SkillActivations = () => {
  const dispatch = useDispatch();
  const [graphData, setGraphData] = useState([]);
  const {
    analytics_skill_activation,
    range,
    app,
    isLoading,
    // error,
  } = useSelector(({ graphState, filtersState }) => ({
    analytics_intent: graphState.analytics_intent,
    range: filtersState.range,
    app: filtersState.app,
    isLoading: graphState.isLoading,
    error: graphState.error,
  }));
  const fetch = () => {
    dispatch(
      getSkillActivation({
        platform: app.platform,
        apiKey: app.apiKey,
        fromDate: range.from,
        toDate: range.to,
      })
    );
  };
  useEffect(() => {
    fetch();
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (
      analytics_skill_activation &&
      analytics_skill_activation.message === "available"
    ) {
      setGraphData([
        {
          name: "graph_data",
          data: analytics_skill_activation.data.seriesData.data,
        },
      ]);
    }
    // eslint-disable-next-line
  }, [analytics_skill_activation]);

  const [options, setOptions] = useState({
    chart: {
      id: "basic-bar",
    },
    dataLabels: {
      enabled: false,
    },
    grid: {
      show: false,
    },
    legend: {
      show: true,
    },
    xaxis: {
      labels: { show: true },
      categories: [""],
    },
    yaxis: {
      opposite: true,
      labels: { show: true },
    },
  });
  useEffect(() => {
    if (analytics_skill_activation) {
      setOptions({
        ...options,
        xaxis: {
          ...options.xaxis,
          categories: analytics_skill_activation.data.label,
        },
      });
    }
    // eslint-disable-next-line
  }, [analytics_skill_activation]);

  return (
    <div className="skillactivations_container">
      {isLoading && <Loader />}
      <Navbar />
      <Sidebar />
      <div style={{ padding: `0 20px` }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr auto" }}>
          <h1>Skill Activations</h1>
          <h2>{app.name}</h2>
        </div>
        <Filters />
      </div>
      <div className="content">
        <div className="full_section">
          <h2>SKILL ACTIVATION</h2>
          {graphData.length ? (
            <AreaChartBasic data={graphData} custOptions={options} />
          ) : (
            <NoDataAvailable title="Skill Activation" />
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SkillActivations;
